/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import { Option } from '@gcc/configurator';
import LegalDisclaimer from '@gcc/countertops-components/dist/LegalDisclaimer'; // need to port
import { dotcom } from '@gcc/countertops-components/dist/LegalDisclaimer/constants'; // need to port
import PhoneNumber from '@gcc/pip-components/dist/templates/ProductSummary/PhoneNumber';
import RoomVO from '../../components/RoomVO/index';
import { getFeatureGates } from '../../utils/featureGates';
import optionGroupTemplates from './templates/optionGroups';
import reRenderPropCheck from '../../utils/reRenderPropCheck';
import { Mobile } from './templates/optionGroups/optionGroupStyles';
import { saveConfig } from '../../actions/designActions';

const optionGroupSort = (groups) => sortBy(groups, ({ sequenceNumber }) => sequenceNumber);

const renderOption = (option) => <Option key={option.internalName} option={option} />;

const shouldRenderGroup = (options, optionsById) => {
  const haveActiveOptions = options.filter((option) => {
    const activeChoices = Object.values(optionsById).filter(
      (optionById) => optionById.id === option && optionById.isActive === true
    );

    return activeChoices.length > 0;
  });

  return haveActiveOptions.length > 0;
};

const renderGroup = (group, optionsById) => {
  if (!shouldRenderGroup(group.options, optionsById)) {
    return null;
  }

  const OptionGroup =
    optionGroupTemplates.find((template) => template.name === group.name) ||
    optionGroupTemplates.find((template) => template.name === 'Default');
  const OptionGroupTemplate = OptionGroup.template;

  const renderedOptions = group.options.map((option) => renderOption(optionsById[option]));

  return (
    <OptionGroupTemplate key={group.sequenceNumber} group={group}>
      {renderedOptions}
    </OptionGroupTemplate>
  );
};

const renderConfigurations = (groups, optionsById) =>
  optionGroupSort(groups).map((group) => renderGroup(group, optionsById));

const Layout = ({
  groups,
  optionsById,
  contactNumber,
  externalId,
  useRoomVOIntegration,
  roomVOIntegrationUrl,
  storeNumber,
  isMobile,
}) => {
  if (isEmpty(optionsById.allIds)) return null;

  const enableCecContactNumbers = getFeatureGates()?.enableCecContactNumbers;

  // Translate the complex object of options into an array of options.
  // const optionsByInternalName = keyBy(options, 'internalName');

  // Sort the options by their sequence.
  // const collection = sortBy(optionsByInternalName, 'sequence').map(o => o);

  return (
    <div className="buybox" data-section="buybox">
      <div className="buybox__super-sku">
        <div className="product_sku_Overlay_ListBoxes u__clearfix" key="renderConfigurations">
          {useRoomVOIntegration && isMobile && (
            <RoomVO
              useRoomVOIntegration={useRoomVOIntegration}
              appName="countertop"
              roomVOAppScriptId="countertops_room_vo"
              roomVOIntegrationUrl={roomVOIntegrationUrl}
              storeNumber={storeNumber}
              externalId={externalId}
              isPcp
            />
          )}
          {renderConfigurations(groups, optionsById)}
        </div>
        {contactNumber && enableCecContactNumbers && (
          <Mobile>
            <PhoneNumber contactNumber={contactNumber} />
          </Mobile>
        )}
        <LegalDisclaimer
          header={dotcom.header}
          disclaimer={dotcom.disclaimer}
          key="LegalDisclaimer"
          showLinks={false}
        />
      </div>
    </div>
  );
};

Layout.propTypes = {
  groups: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  optionsById: PropTypes.shape({}).isRequired,
  contactNumber: PropTypes.string.isRequired,
  externalId: PropTypes.number.isRequired,
  useRoomVOIntegration: PropTypes.bool,
  roomVOIntegrationUrl: PropTypes.string.isRequired,
  storeNumber: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

Layout.defaultProps = {
  useRoomVOIntegration: false,
  groups: undefined,
};

const mapStateToProps = (state) => ({
  groups: state.configurator.groups,
  optionsById: state.configurator.options,
  contactNumber: state.config.pcpSupportPhoneNumber,
  externalId: state.countertops.selectedColor.sampleOmsId,
  useRoomVOIntegration: state.config.useRoomVOIntegration,
  roomVOIntegrationUrl: state.config.roomVOIntegrationUrl,
  storeNumber: state.store.storeNumber,
});

function mapDispatchToProps(dispatch) {
  return {
    save: () => dispatch(saveConfig()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null, reRenderPropCheck)(Layout);
